<script setup lang="ts">
import { ElementHeader, ElementSubheader, ElementFooter } from '~/components/element'
import { ButtonIcon } from '@caks/uikit/button'
import { IconChat, IconCross } from '@caks/uikit/icon'
import { IiChat } from '@caks/shared/modules/ii'

const isChatVisible = ref(false)

const openModal = () => {
  isChatVisible.value = !isChatVisible.value
}

const locationModalIsOpen = ref(false)
const openLocationModal = () => {
  locationModalIsOpen.value = true
}
</script>

<template>
  <div class="layout__wrapper" @click="isChatVisible = false">
    <div>
      <div class="layout__header">
        <element-header @getLocation="openLocationModal" />
        <element-subheader />
      </div>
      <div class="layout">
        <slot :locationModalIsOpen="locationModalIsOpen" />
        <div class="layout__button">
          <button-icon :icon="IconChat" state="circle" @click.stop="openModal" />
        </div>
        <transition name="chat">
          <div v-if="isChatVisible" class="layout__chat-wrapper" @click.stop>
            <div class="layout__chat-heeader">
              <h1>Чат поддержки</h1>
              <button-icon :icon="IconCross" state="circle" @click="openModal" />
            </div>
            <div class="layout__chat">
              <ii-chat desktop />
            </div>
          </div>
        </transition>
      </div>
    </div>
  </div>
  <element-footer />
</template>

<style scoped lang="scss">
.layout {
  height: auto;
  position: relative;

  &__wrapper {
    min-height: 100dvh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  &__header {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 10;
  }

  &__button {
    position: fixed;
    bottom: 24px;
    right: 24px;

    &::v-deep {
      button {
        width: 57px;
        height: 57px;
      }
    }
  }

  &__chat-wrapper {
    position: fixed;
    right: 24px;
    bottom: 24px;
    z-index: 50;

    max-width: 448px;
    width: 100%;
    max-height: 720px;
    border-radius: 20px;
    background: #fafafa;

    display: flex;
    flex-direction: column;

    box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.07);
  }

  &__chat-heeader {
    padding: 32px;
    position: relative;

    @include h1-1;
    color: $primary-text;

    button {
      position: absolute;
      top: -22px;
      right: -22px;
      max-height: 44px;
      max-width: 44px;
      min-height: 44px;
      min-width: 44px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__chat {
    height: 720px;
    overflow: hidden;
  }
}

.chat-enter-active,
.chat-leave-active {
  transform: translateY(0);
  transition: all 0.15s ease;
}

.chat-enter-from,
.chat-leave-to {
  transform: translateY(50%);
  opacity: 0;
}
</style>
